import { createSlice } from "@reduxjs/toolkit";
// import { getMedicalOrders } from "../../reducer/insuranceMedicalOrders/InsuranceMedicalOrdersReducer";
import { getMedicalOrders } from "../../reducer/insuranceMedicalOrders/insuranceMedicalOrdersReducer";

const initialState = {
  data: {
    claims: [],
    pagination: {},
  },
  isLoading: false,
  error: null,
};

const medicalOrdersSlice = createSlice({
  name: "medicalOrders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMedicalOrders.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getMedicalOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {};
      })
      .addCase(getMedicalOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default medicalOrdersSlice.reducer;
